import { css } from "@styled-system/css";

export const formClass = css({
	width: "[50vw]",
});
